export enum ErrorTypeEnum {
  ServiceError,
  ClientError
}
